import React from 'react'
import ReactOnRails from "react-on-rails/client";

import TopNavBar from './TopNavBar'
import TopActions from './TopActions'
import SelectBox from './Select'
import DatePicker from './DatePicker'
import Feed from '../../frontend/Account/Feed'
import CalendarLayout from './Calendar/CalendarLayout'
import EditOptionals from './RentalReservation/EditOptionals'
import SelectProvider from './DriverReservation/SelectProvider'
import SelectProvider2 from './SelectProvider2'

ReactOnRails.register({TopNavBar, TopActions, SelectBox, DatePicker, Feed, CalendarLayout, EditOptionals, SelectProvider, SelectProvider2})


// document.addEventListener("turbolinks:before-cache", () =>  WebpackerReact.unmountComponents() )
